import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ICompoundDetailsModel, ICompoundIngredientModel } from 'src/app/inventory/interfaces/compound-details.interface';
import { getFlatObject } from 'src/app/shared/helpers/helpers';
import { ActivityTypesEnum } from 'src/app/shared/interfaces/ActivityTypesEnum';
import { FieldType } from 'src/app/shared/interfaces/field-type.enum';
import { GenericTableColumn } from 'src/app/shared/interfaces/genetic-table-column';
import { RowType } from 'src/app/shared/interfaces/raw-type.enum';
import { ITransactionInTableModel } from 'src/app/shared/interfaces/transaction-in-table-model.interface';
import { NavigatedFromPipe } from 'src/app/shared/pipes/navigated-from/navigated-from.pipe';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';
import { GetCompoundDetails, SetWidgetData } from 'src/app/shared/states/transactions/transactions.actions';
import { TransactionsState } from 'src/app/shared/states/transactions/transactions.state';

@Component({
  selector: 'app-compound-details',
  templateUrl: './compound-details.component.html',
  styleUrls: ['./compound-details.component.scss', '../../../inventory.scss']
})
@UntilDestroy()
export class CompoundDetailsComponent implements OnInit {
  
  @Select(TransactionsState.compoundDetails) compoundDetails$: Observable<ICompoundDetailsModel>;

  compoundDetailsFlat: any;

  compoundColumns: GenericTableColumn<ICompoundDetailsModel>[] = [];
  ingredientColumns: GenericTableColumn<ITransactionInTableModel>[] = [];
  wasteColumns: GenericTableColumn<ITransactionInTableModel>[] = [];


  ingredients: ICompoundIngredientModel[] = [];
  waste: ICompoundIngredientModel[] = [];

  currentTab: 'Ingredients' | 'Waste' = 'Ingredients';

  navigationState: any;
  /**
   *
   */
  constructor(
    private router: Router,
    private navigatedFromPipe: NavigatedFromPipe,
    private store: Store,
    private route: ActivatedRoute,

  ) {
    this.navigationState = router.getCurrentNavigation()?.extras?.state;
    const id = this.route.snapshot.params?.id;
    this.store.dispatch(new SetWidgetData(null));
    this.store.dispatch(new GetCompoundDetails(id));
    this.initCompoundCols();
    this.initIngredientCols();
    this.initWasteCols();
  }
  ngOnInit(): void {
    this.compoundDetails$.pipe(untilDestroyed(this))
    .subscribe(val => {
      if (val) {
        this.ingredients = val.ingredients.filter(x => x.activityType === ActivityTypesEnum.Mixed);
        this.waste = val.ingredients.filter(x => x.activityType === ActivityTypesEnum.WastedDestroyed);
      }

    });
  }

  navigateBack() {
    const navigatedFrom = this.navigatedFromPipe.transform(this.navigationState, 'Compounds', '/inventory/compounds')?.link;
    this.router.navigate([navigatedFrom], {state: {
      isNavigatedBack: true
    }});
  }

  private initCompoundCols(): void {
    this.compoundColumns =  [
      this.getDrugCol(), 
      new GenericTableColumn<ICompoundDetailsModel>({ header: 'Package Size', field: 'packageSize', sortable: false, fieldType: FieldType.Text, style: {width: '11%'}}),
    ];

      if (this.store.selectSnapshot(PharmacyState.inventoryLocationsEnabled)) {
        this.compoundColumns.push( this.getLocationCol());
      }

      this.compoundColumns.push(
        ...this.getInventoryCols()
    );
  }

  private initIngredientCols(): void {
    this.ingredientColumns =  [
      this.getDrugCol()
    ];

      if (this.store.selectSnapshot(PharmacyState.inventoryLocationsEnabled)) {
        this.ingredientColumns.push(this.getLocationCol());
      }

      this.ingredientColumns.push(...this.getInventoryCols());
  }

  private initWasteCols(): void {
    this.wasteColumns =  [
      this.getDrugCol(), 
      new GenericTableColumn<ICompoundDetailsModel>({
        header: 'Witness',
        RowType: RowType.Double,
        doubleRowField: {
          headingField: 'witness.firstName',
          headingFieldType: FieldType.Text,
          headingField2: 'witness.lastName',
          headingField2Type: FieldType.LastName,
          secondaryField1: 'witnessDate',
          secondaryFieldType1: FieldType.DateTime,
        },
        style: {width: '11%'}
      }),
    ];

      if (this.store.selectSnapshot(PharmacyState.inventoryLocationsEnabled)) {
        this.wasteColumns.push(this.getLocationCol());
      }

      this.wasteColumns.push(
        ...this.getInventoryCols()
    );
  }

  private getDrugCol(): any {
    return new GenericTableColumn<ICompoundDetailsModel>({ header: 'Drug', field: 'drug.friendlyName',  RowType: RowType.Double,
      doubleRowField: {
        headingField: 'drug.friendlyName', headingFieldType: FieldType.Text, 
        secondaryField1: 'drug.packageNdc', secondaryFieldType1: FieldType.Text
      }});
  }

  private getLocationCol(): any {
    return new GenericTableColumn<ITransactionInTableModel>({ header: 'Location', field: 'locationName', sortable: false, style: {width: '20%'}});
  }

  private getInventoryCols(): any {
    return [
      new GenericTableColumn<ITransactionInTableModel>({ header: 'Starting', field: 'startingQuantity', sortable: false, fieldType: FieldType.Number, style: {width: '10%'}}),
      new GenericTableColumn<ITransactionInTableModel>({ header: 'Count', field: 'addedQuantity', sortable: false, fieldType: FieldType.Number, style:{ width: '10%'}, class: 'background-yellow-50'}), 
      new GenericTableColumn<ITransactionInTableModel>({ header: 'On-Hand', field: 'endingQuantity', sortable: false, fieldType: FieldType.Number, style: {width: '10%'}}),
      new GenericTableColumn<ITransactionInTableModel>({ header: '', field: '' as any, sortable: false, style: {width: '5%'}})
    ];
  }



}
